import { render, staticRenderFns } from "./DataQualityCreatePage.vue?vue&type=template&id=ec70de0c&lang=pug"
import script from "./DataQualityCreatePage.vue?vue&type=script&lang=js"
export * from "./DataQualityCreatePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec70de0c')) {
      api.createRecord('ec70de0c', component.options)
    } else {
      api.reload('ec70de0c', component.options)
    }
    module.hot.accept("./DataQualityCreatePage.vue?vue&type=template&id=ec70de0c&lang=pug", function () {
      api.rerender('ec70de0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/data-platform/modules/data_quality_dataplex/DataQualityCreatePage.vue"
export default component.exports